import React from 'react'
import { CardWithIcon } from '../../elements/CardWithIcon'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { HeadingStyle, mq } from '../../utils'
import { useSpacing } from 'marketing-site/src/library/providers/spacingProvider'
import { ColorIdTokenType, COLOR_TOKENS } from '../../utils/constants/color-tokens'
import classNames from 'classnames'

export const CardsWithIcon: React.FC<IProps> = ({
  header,
  subheader,
  cards,
  headerFontStyle,
  backgroundColor = 'white',
}) => {
  const getHeadingTextSize = (style?: HeadingStyle) => {
    switch (style) {
      case HeadingStyle.Small:
        return 'heading-3'

      case HeadingStyle.Large:
      default:
        return 'heading-2'
    }
  }

  const backgroundColorHex = COLOR_TOKENS[backgroundColor as ColorIdTokenType].hex
  const spacing = useSpacing()
  const wrapperClass = classNames('cards-with-icon-wrapper', {
    'cards-with-icon-wrapper--padding': !spacing,
  })

  return (
    <>
      <div className={wrapperClass}>
        <div className="cards-with-icon">
          {header ? (
            <h2 className="cards-with-icon__header">
              <Text brand="default" size={getHeadingTextSize(headerFontStyle)}>
                {header}
              </Text>
            </h2>
          ) : null}
          {subheader && (
            <div className="cards-with-icon__subheader">
              <Text brand="default" size="heading-4">
                {subheader}
              </Text>
            </div>
          )}
          <ul className="cards-with-icon__content">
            {cards.map((card) => (
              <li key={card.title} className="cards-with-icon__item">
                <CardWithIcon {...card} />
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style jsx>
        {`
          .cards-with-icon-wrapper {
            background-color: ${backgroundColorHex};
            &--padding {
              padding-top: 4rem;
              padding-bottom: 4rem;
            }
          }

          .cards-with-icon {
            max-width: $container-max-width;
            position: relative;
            margin: 0 auto;
            padding-left: 2.5rem;
            padding-right: 2.5rem;

            &__header,
            &__subheader,
            &__content {
              grid-column: content;
              text-align: center;
            }

            &__subheader {
              margin: 1rem 0 0;

              :global(> *) {
                grid-column: content;
              }
            }

            * + &__content {
              margin-top: 3rem;
            }

            &__content {
              display: grid;
              grid-template-columns: 1fr;
              grid-gap: 3rem;
            }
          }

          @media (${mq.tablet}) {
            .cards-with-icon {
              &__subheader {
                margin: 1rem calc(100% / 14 * 3) 0;
              }

              &__content {
                grid-template-columns: repeat(4, 1fr);
              }

              &__item {
                grid-column: span 2;

                &:nth-child(3) {
                  grid-column: 2/4;
                }
              }
            }
          }

          @media (${mq.desktop}) {
            .cards-with-icon-wrapper {
              &--padding {
                padding-top: 6.25rem;
                padding-bottom: 6.25rem;
              }
            }
            .cards-with-icon {
              padding-left: 2.5rem;
              padding-right: 2.5rem;

              * + &__content {
                margin-top: 4rem;
              }

              &__content {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-column-gap: 2.75rem;
              }

              &__item {
                grid-column: span 1;

                &:nth-child(3) {
                  grid-column: span 1;
                }
              }
            }
          }

          @media (${mq.desktopLg}) {
            .cards-with-icon {
              padding-left: 0;
              padding-right: 0;
            }
          }
        `}
      </style>
    </>
  )
}
